import { render, staticRenderFns } from "./sonRoomList.vue?vue&type=template&id=0fbbc727&scoped=true"
import script from "./sonRoomList.vue?vue&type=script&lang=js"
export * from "./sonRoomList.vue?vue&type=script&lang=js"
import style0 from "./sonRoomList.vue?vue&type=style&index=0&id=0fbbc727&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbbc727",
  null
  
)

export default component.exports